import { colors } from '../StyleGuide/Colors'

export const theme = {
   modalCloseButton: {
      closeIconFillColor: colors['gray-700'],
      buttonBgBlurHoverColor: 'hover:bg-[#00000025]',
      buttonBgBlurColor: 'bg-[#0000001A]'
   },
   common: {
      defaultHoverBgColor: 'hover:bg-gray-50',
      toolTip: {
         bgColor: 'bg-gray-900',
         textColor: 'text-base-white'
      },
      successVariantIconColor: colors['teal-600'],
      secondaryHoverBgColor: 'hover:bg-gray-100'
   },
   tableReadableField: {
      cellTextColor: 'text-gray-600',
      phoneNumberTextColor: 'text-gray-600',
      agentNameTextColor: 'text-gray-600',
      leadNameTextColor: 'text-gray-600',
      urlTextColor: 'text-primary-600',
      scoreTextColor: 'text-gray-800',
      totalScoreTextColor: 'text-gray-700',
      multiSelectFieldBorderColor: 'border-gray-300',
      whatsAppIconColors: 'border-gray-300 bg-white',
      callIconColors: 'border-gray-300 bg-white',
      leadRemarks: {
         remarksTextColor: 'text-gray-600',
         closeIconColor: colors['gray-500'],
         alignSelfIconColor: colors['gray-700'],
         remarksDescriptionColor: 'text-gray-800',
         remarksHeaderBorderColor: 'border-gray-300',
         remarkTableTextColor: 'text-gray-600',
         iconColor: colors['gray-500'],
         attachmentIconColor: colors['gray-600'],
         retryIconColor: colors['gray-700'],
         dividerColor: 'border-gray-300'
      },
      cellDetailsModal: {
         headerTextColor: 'text-gray-600',
         contentTextColor: 'text-gray-800',
         headerBorderColor: 'border-gray-300',
         closeIconColor: colors['gray-500']
      },
      contactBulkActions: {
         popoverBorderColor: 'border-gray-300',
         popoverBgColor: 'bg-base-white',
         rockerIconColor: colors['gray-700'],
         xCloseIconColor: colors['gray-400'],
         hrLineColor: 'bg-gray-300'
      },
      tooltip: {
         tooltipTextColor: 'text-bg-white',
         tooltipBGColor: 'bg-gray-900'
      },
      cellButton: {
         borderColor: 'border-gray-300',
         hoverBgColor: 'bg-gray-50',
         markerIconColor: colors['gray-500']
      },
      googleMapsView: {
         currentLocationRadiusFillColor: 'bg-primary-400',
         currentLocationBorderColor: 'border-base-white',
         currentLocationFillColor: 'bg-primary-600',
         defaultBorderColor: 'border-gray-300',
         disabledIconColor: colors['gray-300'],
         defaultIconColor: colors['gray-500'],
         backgroundColor: 'bg-base-white',
         errorMessageColor: 'text-error-500',
         clearIconColor: colors['error-600'],
         clearTextColor: 'text-error-600',
         errorBorderColor: 'border-error-300',
         labelColor: 'text-gray-700',
         titleTextColor: 'text-gray-900',
         degreesTextColor: 'text-gray-400',
         tooltipBgColor: 'bg-gray-900',
         inputDisabledBgColor: 'bg-gray-50',
         seeMoreTextColor: 'text-gray-600',
         coordinateValueTextColor: 'text-gray-500'
      }
   },
   cellDetailsModal: {
      headerTextColor: 'text-gray-600',
      contentTextColor: 'text-gray-800',
      headerBorderColor: 'border-gray-300',
      closeIconColor: colors['gray-500']
   },
   uploadedFilesList: {
      uploadedFileTextColor: 'text-gray-700',
      uploadedFileListTypeTextColor: 'text-primary-600',
      uploadedFileListTypeIconColor: colors['primary-600'],
      uploadedFileIconColor: colors['gray-700'],
      defaultBorderColor: 'border-gray-300'
   },
   fieldOptionsAsyncComboBox: {
      tickMarkColor: colors['primary-600'],
      inputTextColor: 'text-gray-900',
      customOptionHoverColor: 'hover:bg-gray-50',
      customOptionBgColor: 'bg-gray-50',
      customOptionTextColor: 'text-gray-700',
      searchIconFillColor: colors['gray-500'],
      customOptionSupportTextColor: 'text-gray-500'
   },
   fileUploaderField: {
      defaultBorderColor: 'border-gray-300',
      titleColor: 'text-gray-900',
      descriptionColor: 'text-gray-600',
      uploadedFilesCountTextColor: 'text-gray-700',
      maxLimitReachedColor: 'text-gray-600',
      uploadedFilesActions: {
         defaultActionIconColor: colors['gray-500'],
         labelColors: 'text-gray-900',
         sectionDividerColors: 'bg-gray-300 border-gray-300',
         actionsHoverBgColor: 'hover:bg-gray-50'
      },
      addAttachment: {
         iconColor: colors['primary-600'],
         textColor: 'text-primary-600',
         textDisabledColor: 'text-gray-300',
         iconDisabledColor: colors['gray-300'],
         lineBgColor: 'bg-gray-200'
      },
      fileInfo: {
         fileNameColor: 'text-gray-600'
      }
   },
   launchMode: {
      defaultBgColor: 'bg-base-white',
      titleTextColor: 'text-gray-800',
      descriptionTextColor: 'text-gray-600',
      footerTextColor: 'text-gray-700'
   },
   simpleTable: {
      tableCell: {
         cellTextColor: 'text-gray-600'
      },
      copyIconColor: colors['gray-500']
   },
   pipelinePicker: {
      tickIconColor: colors['primary-600'],
      customOptionHoverBgColor: 'hover:bg-gray-50',
      selectedPipelineBGColor: 'bg-primary-50'
   },
   pipelineItemStageField: {
      customOptionHoverBgColor: 'hover:bg-gray-50',
      focusBgColor: 'bg-gray-50',
      selectedBgColor: 'bg-gray-50',
      customOptionTextColor: 'text-gray-900',
      customBadgeTextColor: 'text-gray-700',
      checkIconColor: colors['primary-600'],
      badgeBorderColor: 'border-gray-300',
      badgeCloseIconColor: colors['gray-400']
   },
   colorPicker: {
      textColor: 'text-gray-900',
      selectedBorderColor: 'border-primary-600',
      hoveredBorderColor: 'border-gray-300',
      focusRingColor: 'ring-gray-100',
      colors: {
         BLUE: 'bg-blue-600',
         BLUE_DARK: 'bg-blue-dark-600',
         BLUE_LIGHT: 'bg-blue-light-600',
         CYAN: 'bg-cyan-600',
         FUCHSIA: 'bg-fuchsia-600',
         GREEN: 'bg-green-600',
         GREEN_LIGHT: 'bg-green-light-600',
         INDIGO: 'bg-indigo-600',
         MOSS: 'bg-moss-600',
         ORANGE: 'bg-orange-600',
         ORANGE_DARK: 'bg-orange-dark-600',
         PINK: 'bg-pink-600',
         PURPLE: 'bg-purple-600',
         ROSE: 'bg-rose-600',
         TEAL: 'bg-teal-600',
         VIOLET: 'bg-violet-600',
         YELLOW: 'bg-yellow-600'
      },
      trigger: {
         borderColor: 'border-gray-300',
         bgColor: 'bg-base-white'
      }
   },
   progressBar: {
      labelColor: 'text-gray-700',
      backgroundColor: 'bg-gray-200',
      progressBgColor: 'bg-success-600',
      failedBarBgColor: 'bg-error-600'
   }
}
